module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/14-fc0e5dcc9d55b2eca91dd70deec89dfd.png";